import { render, staticRenderFns } from "./OtherBenefitsDetails.vue?vue&type=template&id=00549825&scoped=true"
import script from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./OtherBenefitsDetails.vue?vue&type=style&index=0&id=00549825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00549825",
  null
  
)

export default component.exports